<template>
    <div class="authorityManage">
        <div class="leftStructure">
            <div class="tree-box" style="padding:20px;">
                <tree
                    ref="tree"
                    title="权限树"
                    :sourceData="treeData"
                    :formatTreeData="treeFormat"
                    :treeEdit="treeEdit"
                    :defExpandNode="treeExpandNode"
                    @clickTreeNode="clickTree"
                    @freshTreeData="freshTree">
                </tree>
            </div>
        </div>
        <div class="centerStructure">
            <div class="editPart">
                <el-row :gutter="20" class="row-margin-bottom">
                    <el-col :span="24" >
                        <label class="authorityTypeClass">权限类型：</label>
                        <el-select class="input-width" :disabled="authorityDisabled" v-model="authorityType" placeholder="请选择">
                            <el-option 
                                class="input-width"
                                v-for="item in authorityTypeOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>
                </el-row>
                <!-- 模块 -->
                <el-form
                    v-show="moduleFlag" 
                    :rules="moduleRules"
                    :label-position="labelPosition" 
                    :model="moduleForm"
                    label-width="150px" 
                    ref="moduleRuleForm">
                    <el-row :gutter="20">
                        <el-col :span="24">
                            <el-form-item label="模块名称：" prop="moduleName">
                                <el-input class="input-width" v-model.trim="moduleForm.moduleName" placeholder="请输入模块名称"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="模块英文名称：" prop="moduleEnName">
                                <el-input class="input-width" v-model.trim="moduleForm.moduleEnName" placeholder="请输入模块英文名称"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="排序码：" prop="sortCode">
                                <el-input class="input-width" v-model.trim="moduleForm.sortCode" placeholder="请输入排序码，1-9999之间"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="菜单类型：" prop="moduleTypeId">
                                <el-select class="input-width" v-model="moduleForm.moduleTypeId" placeholder="请选择">
                                    <el-option 
                                        class="input-width" 
                                        v-for="item in moduleTypeOptions"
                                        :key="item.id"
                                        :label="item.dictionaryName"
                                        :value="item.id"
                                        :disabled="item.isEnable">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="权限种类：" prop="permissionTypeId">
                                <el-checkbox-group v-model="moduleForm.permissionTypeId" >
                                    <el-checkbox v-for="pType in permissionTypeOptions" :label="pType.id" :key="pType.id">{{pType.name}}</el-checkbox>
                                </el-checkbox-group>
                                <!-- <el-select class="input-width" v-model="moduleForm.permissionTypeId" placeholder="请选择">
                                    <el-option
                                        class="input-width" 
                                        v-for="item in permissionTypeOptions"
                                        :key="item.id"
                                        :label="item.dictionaryName"
                                        :value="item.id"
                                        :disabled="item.isEnable">
                                    </el-option>
                                </el-select> -->
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="icon名称：">
                                <el-input class="input-width" v-model.trim="moduleForm.iconName" placeholder="请输入icon名称"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="路由名称：" prop="routeName">
                                <el-input class="input-width" v-model.trim="moduleForm.routeName" placeholder="请输入路由名称"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="启用：">
                                <el-radio-group class="wh200" v-model="moduleForm.enable">
                                    <el-radio border :label=true >是</el-radio>
                                    <el-radio border :label=false >否</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="一级菜单：">
                                <el-radio-group class="wh200" v-model="moduleForm.title">
                                    <el-radio border :label=true >是</el-radio>
                                    <el-radio border :label=false >否</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                        <el-col :span="18"></el-col>
                        <el-col :span="24">
                            <el-form-item>
                                <el-button type="primary" v-show="showModuleSubmit" size="medium" @click="moduleSubmit('moduleRuleForm')">提 交</el-button>
                                <el-button type="danger" v-show="isUpdate && deleteModuleFlag" size="medium" @click="moduleDelete()" >删 除</el-button>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
                <!-- 许可权限 -->
                <el-form
                    v-show="permissionFlag" 
                    :rules="permissionRules"
                    :label-position="labelPosition" 
                    :model="permissionForm"
                    label-width="150px" 
                    ref="permissionRuleForm">
                    <el-row :gutter="20">
                        <el-col :span="24">
                            <el-form-item label="权限名称：" prop="permissionName">
                                <el-input class="input-width" v-model.trim="permissionForm.permissionName" placeholder="请输入权限名称"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="权限英文名称：" prop="permissionEnName">
                                <el-input class="input-width" v-model.trim="permissionForm.permissionEnName" placeholder="请输入权限英文名称"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="唯一标识码：" prop="identificationCode">
                                <el-input class="input-width" v-model.trim="permissionForm.identificationCode" placeholder="请输入唯一标识码"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="权限种类：" prop="permissionTypeId1">
                                <el-checkbox-group v-model="permissionForm.permissionTypeId1" >
                                    <el-checkbox v-for="pType in permissionTypeOptions" :label="pType.id" :key="pType.id">{{pType.name}}</el-checkbox>
                                </el-checkbox-group>
                                <!-- <el-select class="input-width" v-model="permissionForm.permissionTypeId1" placeholder="请选择">
                                    <el-option
                                        class="input-width" 
                                        v-for="item in permissionTypeOptions"
                                        :key="item.id"
                                        :label="item.dictionaryName"
                                        :value="item.id"
                                        :disabled="item.isEnable">
                                    </el-option>
                                </el-select> -->
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="启用：">
                                <el-radio-group class="wh200" v-model="permissionForm.enable">
                                    <el-radio border :label=true >是</el-radio>
                                    <el-radio border :label=false >否</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="请求：">
                                <el-radio-group class="wh200" v-model="permissionForm.request">
                                    <el-radio border :label=true >是</el-radio>
                                    <el-radio border :label=false >否</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                        <el-col :span="18"></el-col>
                        <el-col :span="24">
                            <el-form-item label="请求类型：" prop="requestType">
                                <el-select class="input-width" :disabled="nonRequestDisabled" v-model="permissionForm.requestType" placeholder="请选择">
                                    <el-option 
                                        class="input-width" 
                                        v-for="item in requestTypeOptions"
                                        :key="item.id"
                                        :label="item.dictionaryName"
                                        :value="item.id"
                                        :disabled="item.isEnable">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="请求路径：" prop="functionUrl">
                                <el-input class="input-width" :disabled="nonRequestDisabled" v-model.trim="permissionForm.functionUrl" placeholder="请输入请求路径"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item>
                                <el-button type="primary" v-show="showPermissionSubmit" size="medium" @click="permissionSubmit('permissionRuleForm')">保存</el-button>
                                <el-button type="danger" v-show="isUpdate && deletePermissionFlag" size="medium" @click="permissionDelete()" >删除</el-button>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
import Tree from "@/components/common/Tree"
import { $http } from '@/config/api/axios'
import { Mixins } from '@/config/mixins/mixins'
import { IsInteger, IsNull, IsEnlish, IsNumberForZero } from "@/config/validate/common.js";
import {get_local_cache} from "@/config/cache/cache.js"
export default {
    name: 'authorityManage',
    mixins:[Mixins],
    components:{
        Tree
    },
    data() {
        var checkSortCode = (rule, value, callback) => {
            if (!IsInteger(value)) {
                return callback(new Error("请输入整数值"));
            }
            if(!IsNumberForZero(value)){
                return callback(new Error("请输入整数值"));
            }
            if (value < 1 || value > 9999) {
                return callback(new Error('请输入1-9999之间的整数值'));
            }
            return callback();
        };
        var checkRouteName = (rule, value, callback) =>{
            if(!this.moduleForm.title){
                if(IsNull(value)){
                    return callback(new Error("非标题模块必须填写路由名称"));
                }
                if(!IsEnlish(value)){
                    return callback(new Error("请填写英文字符"));
                }
                if(value.length > 50){
                    return callback(new Error("长度在1到50之间"));
                }
            }
            return callback();
        };
        var checkRequestType = (rule, value, callback) =>{
            if(this.permissionForm.request){
                if(IsNull(value)){
                    return callback(new Error("请求权限,必须选择请求类型"));
                }
            }
            return callback();
        };
        var checkFunctionUrl = (rule, value, callback) =>{
            if(this.permissionForm.request){
                if(IsNull(value)){
                    return callback(new Error("请求权限,必须填写请求路径"));
                }
                if(value.length > 50){
                    return callback(new Error("长度在1到50之间"));
                }
            }
            return callback();
        };
        return {
            addModuleFlag:false,
            updateModuleFlag:false,
            deleteModuleFlag:false,
            addPermissionFlag:false,
            updatePermissionFlag:false,
            deletePermissionFlag:false,
            showModuleSubmit:false,
            showPermissionSubmit:false,
            // 权限树数据源
            treeData:[],
            // 权限树数据形式
            treeFormat:{
                id:"authorityId",
                label:"authorityName",
                pcode:"authorityParentCode",
                code:"authorityCode",
                extra:["authorityType"]
            },
            treeEdit:false,
            treeExpandNode:[],
            authorityDisabled:true,
            authorityType:'',
            authorityTypeOptions:[{
                value: 1,
                label: '模块'
            },{
                value: 2,
                label: '许可权限'
            }],
            labelPosition:"right",

            moduleFlag:false,
            moduleRules:{
                moduleName:[
                    {required:true,message:'不能为空',trigger:'blur'},
                    {min:1,max:20,message:'长度在1到20之间',trigger:'blur'}
                ],
                moduleEnName:[
                    {required:true,message:'不能为空',trigger:'blur'},
                    {min:1,max:50,message:'长度在1到50之间',trigger:'blur'}
                ],
                sortCode: [
                    {required:true,message:'不能为空',trigger:'blur'},
                    { validator: checkSortCode, trigger: 'blur' }
                ],
                moduleTypeId: [
                    { required: true, message: '请选择菜单类型', trigger: 'change' }
                ],
                permissionTypeId: [
                    { required: true, message: '请选择权限种类', trigger: 'change' }
                ],
                routeName: [
                    { validator: checkRouteName, trigger: 'blur' }
                ],
            },
            moduleForm: {
                id:'',
                moduleName:'',
                moduleEnName:'',
                moduleCode:'',
                parentCode:'',
                iconName:'',
                enable:true,
                sortCode:'',
                moduleTypeId:'',
                title:false,
                permissionTypeId:[],
                routeName:''
            },
            moduleTypeOptions:[],
            permissionTypeOptions:[
                {id:4,name:'平台权限'},
                {id:2,name:'运维权限'},
                {id:1,name:'管理员权限'}
            ],
            isUpdate: true,
            addNodeId:'',

            permissionFlag:false,
            permissionRules:{
                permissionName:[
                    {required:true,message:'不能为空',trigger:'blur'},
                    {min:1,max:20,message:'长度在1到20之间',trigger:'blur'}
                ],
                permissionEnName:[
                    {required:true,message:'不能为空',trigger:'blur'},
                    {min:1,max:50,message:'长度在1到50之间',trigger:'blur'}
                ],
                identificationCode:[
                    {required:true,message:'不能为空',trigger:'blur'},
                    {min:1,max:50,message:'长度在1到50之间',trigger:'blur'}
                ],
                permissionTypeId1: [
                    { required: true, message: '请选择权限种类', trigger: 'change' }
                ],
                requestType: [
                    { validator: checkRequestType, trigger: 'change' }
                ],
                functionUrl: [
                    { validator: checkFunctionUrl, trigger: 'blur' }
                ],
            },
            permissionForm: {
                id:'',
                moduleId:'',
                permissionCode:'',
                permissionName:'',
                permissionEnName:'',
                parentCode:'',
                enable:true,
                permissionTypeId1:[],
                requestType:'',
                request:false,
                functionUrl:'',
                identificationCode:''
            },
            requestTypeOptions:[],
            nonRequestDisabled:true,
        }
    },
    watch: {
        authorityType(val) {
            if(this.authorityType == 1){
                this.moduleFlag = true;
                this.permissionFlag = false;
            }else if(this.authorityType == 2){
                this.moduleFlag = false;
                this.permissionFlag = true;
            }
        },
        'permissionForm.request'(val){
            if(this.permissionForm.request){
                this.nonRequestDisabled = false;
            }else{
                this.permissionForm.requestType = '';
                this.permissionForm.functionUrl = '';
                this.nonRequestDisabled = true;
            }
        }
    },
    methods: {
        // 权限树点击事件
        clickTree(data){
            let params = {};
            params.id = data.id;
            if(data.extra.authorityType == 1){
                //模块数据
                this.authorityDisabled = true;
                this.authorityType = 1;
                this.isUpdate = true;
                if(this.updateModuleFlag){
                    this.showModuleSubmit = true;
                }else{
                    this.showModuleSubmit = false;
                }
                $http("get", "module/getModuleById", params).then((res) => {
                    if(res.status == 'SUCCESS'){
                        // 成功或无数据
                        // 赋值
                        this.moduleForm.id = res.data.id;
                        this.moduleForm.moduleName = res.data.moduleName;
                        this.moduleForm.moduleEnName = res.data.moduleEnName;
                        this.moduleForm.moduleCode = res.data.moduleCode;
                        this.moduleForm.parentCode = res.data.parentCode;
                        this.moduleForm.iconName = res.data.iconName;
                        this.moduleForm.enable = res.data.enable;
                        this.moduleForm.sortCode = res.data.sortCode;
                        this.moduleForm.moduleTypeId = res.data.moduleTypeId;
                        this.moduleForm.title = res.data.title;
                        this.moduleForm.permissionTypeId = [];
                        if(res.data.permissionTypeId & 1){
                            this.moduleForm.permissionTypeId.push(1);
                        }
                        if(res.data.permissionTypeId & 2){
                            this.moduleForm.permissionTypeId.push(2);
                        }
                        if(res.data.permissionTypeId & 4){
                            this.moduleForm.permissionTypeId.push(4);
                        }
                        this.moduleForm.routeName = res.data.routeName;
                        this.$refs['moduleRuleForm'].validate();
                    }else{
                        this.msgerror(res.message);
                    }
                });
            }else if(data.extra.authorityType == 2){
                //许可权限
                this.authorityDisabled = true;
                this.authorityType = 2;
                this.isUpdate = true;
                if(this.updatePermissionFlag){
                    this.showPermissionSubmit = true;
                }else{
                    this.showPermissionSubmit = false;
                }
                $http("get", "permission/getPermissionById", params).then((res) => {
                    if(res.status == 'SUCCESS'){
                        // 成功或无数据
                        // 赋值
                        this.permissionForm.id = res.data.id;
                        this.permissionForm.moduleId = res.data.moduleId;
                        this.permissionForm.permissionCode = res.data.permissionCode;
                        this.permissionForm.permissionName = res.data.permissionName;
                        this.permissionForm.permissionEnName = res.data.permissionEnName;
                        this.permissionForm.parentCode = res.data.parentCode;
                        this.permissionForm.enable = res.data.enable;
                        this.permissionForm.permissionTypeId1 = [];
                        if(res.data.permissionTypeId & 1){
                            this.permissionForm.permissionTypeId1.push(1);
                        }
                        if(res.data.permissionTypeId & 2){
                            this.permissionForm.permissionTypeId1.push(2);
                        }
                        if(res.data.permissionTypeId & 4){
                            this.permissionForm.permissionTypeId1.push(4);
                        }
                        this.permissionForm.requestType = res.data.requestType;
                        this.permissionForm.functionUrl = res.data.functionUrl;
                        this.permissionForm.request = res.data.request;
                        this.permissionForm.identificationCode = res.data.identificationCode;
                        this.$refs['permissionRuleForm'].validate();
                    }else{
                        this.msgerror(res.message);
                    }
                });
            }else{
                this.msgerror("节点数据有误，请联系管理员！");
            }
        },
        // 权限树刷新事件
        freshTree(selectId){
            $http("get", "authority/listAllAuthority", {}).then((res) => {
                if(res.status == 'SUCCESS' || res.status == 'NORESOURCES'){
                    // 成功或无数据
                    this.treeExpandNode = [];
                    if(selectId != null){
                        this.treeExpandNode.push(selectId);
                    }
                    this.treeData = res.data;
                    if(this.treeData.length > 0){
                        this.$nextTick(()=>{
                            if(selectId == null){
                                let firstTreeData = this.$refs.tree.treeData[0];
                                this.$refs.tree.setCurrentKey(firstTreeData.id);
                                this.clickTree(firstTreeData);
                            }else{
                                this.$refs.tree.setCurrentKey(selectId);
                                let selectData = this.$refs.tree.getCurrentNode();
                                this.clickTree(selectData);
                            }
                        });
                    }
                }else{
                    this.msgerror(res.message);
                }
            });
        },
        // 权限树添加按钮
        treeAddFun(data){
            this.authorityDisabled = false;
            this.authorityType = 1;
            this.isUpdate = false;
            this.addNodeId = data.id;
            // 赋值
            this.$refs["moduleRuleForm"].resetFields();
            this.moduleForm.id = "";
            this.moduleForm.moduleName = "";
            this.moduleForm.moduleEnName = "";
            this.moduleForm.moduleCode = "";
            this.moduleForm.parentCode = data.code;
            this.moduleForm.iconName = "";
            this.moduleForm.enable = true;
            this.moduleForm.sortCode = "";
            this.moduleForm.moduleTypeId = 1002001;
            this.moduleForm.title = false;
            this.moduleForm.permissionTypeId = [];
            this.moduleForm.routeName = "";
            if(this.addModuleFlag){
                this.showModuleSubmit = true;
            }else{
                this.showModuleSubmit = false;
            }
            
            this.$refs["permissionRuleForm"].resetFields();
            this.permissionForm.id = "";
            this.permissionForm.moduleId = data.id;
            this.permissionForm.permissionCode = "";
            this.permissionForm.permissionName = "";
            this.permissionForm.permissionEnName = "";
            this.permissionForm.parentCode = data.code;
            this.permissionForm.enable = true;
            this.permissionForm.permissionTypeId1 = [];
            this.permissionForm.requestType = "";
            this.permissionForm.functionUrl = "";
            this.permissionForm.identificationCode = "";
            this.permissionForm.request = false;
            if(this.addPermissionFlag){
                this.showPermissionSubmit = true;
            }else{
                this.showPermissionSubmit = false;
            }

        },
        // 保存模块
        moduleSubmit(ref){
            this.$refs[ref].validate((valid) =>{
                if(valid){
                    let moduleParams = {};
                    moduleParams.id = this.moduleForm.id;
                    moduleParams.moduleName = this.moduleForm.moduleName;
                    moduleParams.moduleEnName = this.moduleForm.moduleEnName;
                    moduleParams.moduleCode = this.moduleForm.moduleCode;
                    moduleParams.parentCode = this.moduleForm.parentCode;
                    moduleParams.iconName = this.moduleForm.iconName;
                    moduleParams.enable = this.moduleForm.enable;
                    moduleParams.sortCode = this.moduleForm.sortCode;
                    moduleParams.moduleTypeId = this.moduleForm.moduleTypeId;
                    moduleParams.title = this.moduleForm.title;
                    let submitPermissionTypeId = 0;
                    for(var i = 0; i < this.moduleForm.permissionTypeId.length; i++){
                        submitPermissionTypeId += this.moduleForm.permissionTypeId[i];
                    }
                    moduleParams.permissionTypeId = submitPermissionTypeId;
                    moduleParams.routeName = this.moduleForm.routeName;
                    if(IsNull(this.moduleForm.id)){
                        //添加
                        $http("post", "module/insertModule", moduleParams).then((res) => {
                            if(res.status == 'SUCCESS'){
                                this.msgsuccess(res.message);
                                this.freshTree(this.addNodeId);
                            }else{
                                this.msgerror(res.message);
                            }
                        });
                    }else{
                        //修改
                        $http("post", "module/updateModule", moduleParams).then((res) => {
                            if(res.status == 'SUCCESS'){
                                this.msgsuccess(res.message);
                                this.freshTree(this.moduleForm.id);
                            }else{
                                this.msgerror(res.message);
                            }
                        });
                    }
                }else{
                    return false;
                }
            })
        },
        // 删除模块
        moduleDelete(){
            let selectData = this.$refs.tree.getCurrentNode();
            if(selectData.children != null && selectData.children.length > 0){
                this.msgwarning("存在子节点,无法删除！");
                return;
            }
            this.$confirm('此操作将永久删除模块, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: ''
            }).then(() => {
                //删除
                let moduleId = selectData.id;
                let moduleParams = {};
                moduleParams.id = moduleId;
                let parentId = this.$refs.tree.getParentKey(moduleId);
                $http("post", "module/deleteModule", moduleParams).then((res) => {
                    if(res.status == 'SUCCESS'){
                        this.msgsuccess(res.message);
                        this.freshTree(parentId);
                    }else{
                        this.msgerror(res.message);
                    }
                });
            }).catch(() => {
            });
        },
        //保存权限
        permissionSubmit(ref){
            this.$refs[ref].validate((valid1) =>{
                if(valid1){
                    let permissionParams = {};
                    permissionParams.id = this.permissionForm.id;
                    permissionParams.moduleId = this.permissionForm.moduleId;
                    permissionParams.permissionCode = this.permissionForm.permissionCode;
                    permissionParams.permissionName = this.permissionForm.permissionName;
                    permissionParams.permissionEnName = this.permissionForm.permissionEnName;
                    permissionParams.parentCode = this.permissionForm.parentCode;
                    permissionParams.enable = this.permissionForm.enable;
                    let submitPermissionTypeId = 0;
                    for(var i = 0; i < this.permissionForm.permissionTypeId1.length; i++){
                        submitPermissionTypeId += this.permissionForm.permissionTypeId1[i];
                    }
                    permissionParams.permissionTypeId = submitPermissionTypeId;
                    permissionParams.requestType = this.permissionForm.requestType;
                    permissionParams.request = this.permissionForm.request;
                    permissionParams.functionUrl = this.permissionForm.functionUrl;
                    permissionParams.identificationCode = this.permissionForm.identificationCode;
                    if(IsNull(this.permissionForm.id)){
                        //添加
                        $http("post", "permission/insertPermission", permissionParams).then((res) => {
                            if(res.status == 'SUCCESS'){
                                this.msgsuccess(res.message);
                                this.freshTree(this.addNodeId);
                            }else{
                                this.msgerror(res.message);
                            }
                        });
                    }else{
                        //修改
                        $http("post", "permission/updatePermission", permissionParams).then((res) => {
                            if(res.status == 'SUCCESS'){
                                this.msgsuccess(res.message);
                                this.freshTree(this.permissionForm.id);
                            }else{
                                this.msgerror(res.message);
                            }
                        });
                    }
                }else{
                    return false;
                }
            })
        },
        // 删除模块
        permissionDelete(){
            let selectData = this.$refs.tree.getCurrentNode();
            if(selectData.children != null && selectData.children.length > 0){
                this.msgwarning("存在子节点,无法删除！");
                return;
            }
            this.$confirm('此操作将永久删除权限, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: ''
            }).then(() => {
                //删除
                let permissionId = selectData.id;
                let permissionParams = {};
                permissionParams.id = permissionId;
                let parentId = this.$refs.tree.getParentKey(permissionId);
                $http("post", "permission/deletePermission", permissionParams).then((res) => {
                    if(res.status == 'SUCCESS'){
                        this.msgsuccess(res.message);
                        this.freshTree(parentId);
                    }else{
                        this.msgerror(res.message);
                    }
                });
            }).catch(() => {
            });
        },
    },
    created(){
        this.freshTree();
        let moduleTypeParams = {};
        moduleTypeParams.typeId = 1004;
        $http("get", "dictionary/listDictionaryByTypeId", moduleTypeParams).then((res) => {
            if(res.status == 'SUCCESS'){
                this.moduleTypeOptions = res.data;
            }else{
                this.msgerror(res.message);
            }
        });
        // let permissionTypeParams = {};
        // permissionTypeParams.typeId = 1008;
        // $http("get", "dictionary/listDictionaryByTypeId", permissionTypeParams).then((res) => {
        //     if(res.status == 'SUCCESS'){
        //         this.permissionTypeOptions = res.data;
        //     }else{
        //         this.msgerror(res.message);
        //     }
        // });
        let requestTypeParams = {};
        requestTypeParams.typeId = 1007;
        $http("get", "dictionary/listDictionaryByTypeId", requestTypeParams).then((res) => {
            if(res.status == 'SUCCESS'){
                this.requestTypeOptions = res.data;
            }else{
                this.msgerror(res.message);
            }
        });
    },
    mounted() {
        let permissions = get_local_cache('permissions');
        if(permissions != null){
            permissions = JSON.parse(permissions);
            for(var i = 0; i < permissions.length; i++){
                if(permissions[i] == "insertModule"){
                    this.addModuleFlag = true;
                }else if(permissions[i] == "updateModule"){
                    this.updateModuleFlag = true;
                }else if(permissions[i] == "deleteModule"){
                    this.deleteModuleFlag = true;
                }else if(permissions[i] == "insertPermission"){
                    this.addPermissionFlag = true;
                }else if(permissions[i] == "updatePermission"){
                    this.updatePermissionFlag = true;
                }else if(permissions[i] == "deletePermission"){
                    this.deletePermissionFlag = true;
                }
            }
            if(this.addModuleFlag || this.addPermissionFlag){
                this.treeEdit = true;
            }
        }
        this.$refs.tree.nodeAdd = (node,data)=>{
            this.treeAddFun(data);
        }
    },
}
</script>

<style lang="less">
.authorityManage{
    width: 100%;
    height: 100%;
    margin-bottom: 10px;
    display: flex;
    .leftStructure{
        overflow: hidden;
        width: 240px;
        height: 100%;
        border-radius: 4px;
        box-shadow: 0px 0px 3px rgba(68, 48, 96, 0.2);
        margin-right: 10px;
        flex-shrink: 0;
    }
    .centerStructure{
        padding: 20px;
        flex: 1;
        height: 100%;
        margin-right: 10px;
        border-radius: 4px;
        box-shadow: 0px 0px 3px rgba(68, 48, 96, 0.2);
        .editPart{
            width: 100%;
            height: 100%;
            .authorityTypeClass{
                width: 144px;
                padding: 0 6px 0 0;
                float: left;
                text-align: right;
                line-height: 32px;
            }
            .row-margin-bottom{
                margin-bottom: 18px;
            }
        }
    }
    .input-width{
        width: 200px;
    }
    .wh200{
        width: 200px;
    }
    .el-radio{
        margin-right:0px; 
    }
}

</style>